export enum QUERY_KEYS {
  // AUTH KEYS
  CREATE_USER_ACCOUNT = "createUserAccount",

  // USER KEYS
  GET_CURRENT_USER = "getCurrentUser",
  GET_USERS = "getUsers",
  GET_USER_BY_ID = "getUserById",

  // POST KEYS
  GET_POSTS = "getPosts",
  GET_INFINITE_POSTS = "getInfinitePosts",
  GET_RECENT_POSTS = "getRecentPosts",
  GET_POST_BY_ID = "getPostById",
  GET_USER_POSTS = "getUserPosts",
  GET_FILE_PREVIEW = "getFilePreview",

  //  SEARCH KEYS
  SEARCH_POSTS = "getSearchPosts",

  //One to One chat Keys
  GET_MESSAGES = "getUserMessages",
  // Live Stream Keys
  GET_LIVE_STREAMS ="getLiveStreams",

  GET_KYC_DETAILS ="getKYCDetails",
  GET_UPCOMING_LIVES = "getUpcomingLives",

  //Following/ Followes keys
 GET_FOLLOW_STATUS= "getFollowStatus",
  GET_FOLLOWERS_COUNT= "getFollowersCount", 
  GET_FOLLOWING_COUNT= "getFollowingCount",
  GET_FOLLOWERS= "getFollowers",
  GET_FOLLOWING= "getFollowing",
  GET_FOLLOWERS_WITH_DETAILS= "getFollowersWithDetails",
  GET_FOLLOWING_WITH_DETAILS= "getFollowingWithDetails",
  GET_MUTUAL_FOLLOW_STATUS= "getMutualFollowStatus",
  GET_BULK_FOLLOW_STATUS= "getBulkFollowStatus",

  GET_MULTIPLE_USERS="getMultipleUsers"
}
